import { reportPossibleNetworkError } from "@frontend/utils/online_status";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

// A request that never reached the server flips the app to "offline" (after a
// confirming probe), so the offline bar shows even on Wi-Fi without internet.
export const queryClient = new QueryClient({
	queryCache: new QueryCache({ onError: reportPossibleNetworkError }),
	mutationCache: new MutationCache({ onError: reportPossibleNetworkError }),
	defaultOptions: {
		queries: {
			retry: 1,
		},
	},
});
